var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfButton',_vm._g({staticClass:"sf-arrow",attrs:{"type":"button"}},_vm.$listeners),[_vm._t("default",function(){return [_c('SfIcon',{staticClass:"sf-arrow__icon",attrs:{"aria-hidden":"true","icon":"arrow_left"}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }